import React from 'react'

const ReportTableComponent = ({
    data,
    formatCurrency,
}) => {
    return (
        <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="max-h-[650px] overflow-auto tiny-scrollbar">
                <table className="min-w-[1800px] border-collapse text-sm text-center">
                    <thead className="sticky top-0 z-10 bg-gray-100">
                        <tr className="border-b border-gray-200">
                            {[
                                "Date",
                                "Total Sales",
                                "VAT",
                                "Net Sales",
                                "Cash",
                                "Mobile Payment",
                                "Credit",
                                "Credit Card",
                                "Split",
                                "Discount Amount",
                                "Start Bill",
                                "End Bill",
                                "Complimentary",
                                "NonChargeable",
                                "Total Guests",
                                "Food Sales",
                                "Beverage Sales",
                                "Other Sales",
                            ].map((header) => (
                                <th
                                    key={header}
                                    className="p-2.5 text-xs font-semibold uppercase tracking-wider text-gray-600 whitespace-nowrap"
                                >
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {data.dailyData.map((row, index) => (
                            <tr
                                key={index}
                                className="border-b border-gray-100 transition-colors hover:bg-gray-50 font-semibold text-gray-700"
                            >
                                <td className="whitespace-nowrap px-2.5 py-2">
                                    {row.Date}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.TOTALSALES)}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.TotalVat)}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.netTOTALSALES)}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.paymentStats?.Cash)}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.paymentStats?.MobilePayment)}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.paymentStats?.Credit)}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.paymentStats?.CreditCard)}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.paymentStats?.Split)}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.DiscountAmt)}
                                </td>

                                <td className="whitespace-nowrap px-2.5 py-2">
                                    {row.StartBill || "-"}
                                </td>

                                <td className="whitespace-nowrap px-2.5 py-2">
                                    {row.EndBill || "-"}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.paymentStats?.Complimentary)}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.paymentStats?.NonChargeable)}
                                </td>

                                <td className="px-2.5 py-2">
                                    {row.TotalGuests}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.Food_Sales)}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.Beverage_Sales)}
                                </td>

                                <td className="px-2.5 py-2">
                                    {formatCurrency(row.Others_Sales)}
                                </td>
                            </tr>
                        ))}
                    </tbody>

                    <tfoot className="sticky bottom-0 bg-gray-100">
                        <tr className="border-t border-gray-200">
                            <td className="p-2.5 font-semibold text-gray-900">
                                Total
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.TOTALSALES)}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.TotalVat)}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.netTOTALSALES)}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.Cash)}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.MobilePayment)}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.Credit)}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.CreditCard)}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.Split)}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.DiscountAmt)}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {data.totalData.min_startbill || "-"}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {data.totalData.max_endbill || "-"}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.Complimentary)}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.NonChargeable)}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {data.totalData.TotalGuests}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.Food_Sales)}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.Beverage_Sales)}
                            </td>

                            <td className="p-2.5 font-semibold text-gray-900">
                                {formatCurrency(data.totalData.Others_Sales)}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    )
}

export default ReportTableComponent